import type { BoxProps } from '@hover/blueprint';
import { Box, Icon } from '@hover/blueprint';
import { iImage } from '@hover/icons';
import React from 'react';

import type { FeaturedProduct } from 'src/modules/renderings/components/RenderingsHub/FeaturedProduct/FeaturedProductCard';

interface FeaturedProductThumbnailProps extends BoxProps {
  imageSize: string;
  featuredProduct: FeaturedProduct;
  isPill?: boolean;
}

interface PlaceholderImageProps extends BoxProps {
  size: string;
  isPill?: boolean;
}

const PlaceholderImage = ({
  size,
  isPill = false,
  ...props
}: PlaceholderImageProps) => (
  <Box
    alignItems="center"
    background="neutral.300"
    borderRadius={300}
    height={size}
    justifyContent="center"
    width={size}
    {...props}
  >
    <Icon color="neutral.700" icon={iImage} size={isPill ? 'tiny' : 'large'} />
  </Box>
);

const FeaturedProductThumbnail = ({
  featuredProduct: { isPaintable, productColorHex, thumbnailSrc },
  imageSize,
  isPill,
  ...props
}: FeaturedProductThumbnailProps) =>
  thumbnailSrc ? (
    <Box
      backgroundBlendMode={
        isPaintable && productColorHex ? 'multiply' : 'unset'
      }
      backgroundColor={
        isPaintable && productColorHex ? productColorHex : 'unset'
      }
      backgroundImage={thumbnailSrc}
      borderRadius={300}
      height={imageSize}
      width={imageSize}
      {...props}
    />
  ) : (
    <PlaceholderImage isPill={isPill} size={imageSize} {...props} />
  );

export { FeaturedProductThumbnail };
